export default __webpack_public_path__ + "static/media/en.10a5bcf0.svg";